import React from "react";
import "./MainMenuItem.css";

const MainMenuItem = ({ label, action }) => (
  <li onClick={action} className="main-menu-item">
    <span>{label}</span>
  </li>
);

export default MainMenuItem;
